import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { Navigation } from "./components/sections/Navigation";
import { HeroSection } from "./components/sections/HeroSection";
import { BrandStory } from "./components/sections/BrandStory";
import { MonthlySpecials } from "./components/sections/MonthlySpecials";
import { ProductScroller } from "./components/sections/ProductScroller";
import { LifestyleGallery } from "./components/sections/LifestyleGallery";
import { InstaFeed } from "./components/sections/InstaFeed";
import { NewsSection } from "./components/sections/NewsSection";
import { LocationSection } from "./components/sections/LocationSection";
import { ContactSection } from "./components/sections/ContactSection";
import { Footer } from "./components/sections/Footer";
import { WhatsAppButton } from "./components/sections/WhatsAppButton";
import MenuPage from "./components/pages/MenuPage";
import ChefPage from "./components/pages/ChefPage";
import AdminPage from "./components/pages/AdminPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function HomePage() {
  useEffect(() => {
    // Defer non-critical seed call
    const timer = setTimeout(() => {
      axios.post(`${API}/seed`).catch(() => {});
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#EEE8DC]">
      <Navigation />
      <HeroSection />
      <BrandStory />
      <LifestyleGallery />
      <MonthlySpecials />
      <ProductScroller />
      <InstaFeed />
      <NewsSection />
      <LocationSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/chef" element={<ChefPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;